import { css } from '@/styled-system/css';

/**
 * Text style with pre-wrap white-space
 * Migrated from StyledPreWrapText
 */
export const preWrapTextStyles = css.raw({
  whiteSpace: 'pre-wrap',
});

/**
 * Single line text with ellipsis
 * Migrated from StyledSingleLineText
 */
export const singleTextLineStyles = css.raw({
  display: 'block',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});
